import { FormSection } from '@ksyos/design-system';
import type { OsasEvaluationData } from '@common/validation/customControls/osas/osasEvaluationSchemas/types';
import { useProcessActivityEditContext } from '@frontend/utils';
import { BooleanRadioGroupFormGroup } from '../../../processActivityFormGroupFields';

export function InformFormSection() {
    const { onChange } = useProcessActivityEditContext<OsasEvaluationData>();

    return (
        <FormSection title="Informeren">
            <BooleanRadioGroupFormGroup
                fieldKey="shouldNotifyGeneralPractitioner"
                label="Huisarts op de hoogte brengen"
                onChange={async (checked) =>
                    onChange(
                        {
                            shouldNotifyGeneralPractitioner: checked,
                        },
                        'messageToGeneralPractitioner'
                    )
                }
                type="radio"
            />
        </FormSection>
    );
}
